// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import oidcManager from "../authentication/oidcManager";

/**
 * Track route changes as page views with AppInsights
 * @param {object} options - Plugin options
 * @param {object} appInsights - appInsights instance
 */
const setupPageTracking = function (options: any, appInsights: any) {
  const router = options.router;
  const baseName = "OutlookAddin";

  router.beforeEach((route: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    const name = baseName + "/" + route.name?.toString();
    appInsights.startTrackPage(name);

    next();
  });
  oidcManager.userProfile;

  router.afterEach((route: RouteLocationNormalized) => {
    const name = baseName + "/" + route.name?.toString();
    const url = location.protocol + "//" + location.host + route.fullPath;
    let properties = {};
    if (oidcManager && oidcManager.userProfile) {
      properties = {
        ...properties,
        userId: oidcManager.userProfile.sub,
        userName: oidcManager.userProfile.name,
        tenantId: oidcManager.userProfile.tid,
      };
    }

    appInsights.stopTrackPage(name, url, properties);
    appInsights.flush();
  });
};

const vueAppInsights = {
  /**
   * Install function passed to Vue.use() show documentation on vue.js website.
   *
   * @param {object} app - Vue instance
   * @param {object} config - Plugin config
   */
  install: (app: any, config: any) => {
    const appInsights = new ApplicationInsights({ config });
    appInsights.loadAppInsights();
    app.config.globalProperties.$appInsights = appInsights;

    const router = config.router;
    if (router) {
      router.isReady().then(() => setupPageTracking(config, appInsights));
    }
  },
};

export default vueAppInsights;
